import { MaskReveal, Reveal } from "../Reveal";
import { ACTIVITY_GALLERY } from "./galleryData";

export function LifeAtAmigo() {
  const main = ACTIVITY_GALLERY[2]!;
  const side = ACTIVITY_GALLERY[8]!;
  const detail = ACTIVITY_GALLERY[14]!;

  return (
    <section className="bg-surface py-24 sm:py-28 lg:py-32" aria-labelledby="life-title">
      <div className="mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-10">
        <div className="grid gap-12 lg:grid-cols-[1.05fr_1fr] lg:items-end lg:gap-16">
          <Reveal>
            <p className="eyebrow text-clay">Good Times and Down-Home Hospitality</p>
            <h2
              id="life-title"
              className="mt-4 font-display text-3xl leading-tight sm:text-4xl lg:text-[2.9rem]"
            >
              The Moments That Make a Stay Special
            </h2>
            <div className="mt-6 space-y-4 text-base leading-relaxed text-muted-foreground sm:text-lg">
              <p>
                The Amigo Inn experience is built around a friendly atmosphere where guests can meet
                one another, share meals, celebrate special occasions, and feel part of the
                community.
              </p>
              <p>
                Throughout the year, the property has hosted get-togethers around Thanksgiving,
                Christmas, New Year&apos;s, the Super Bowl, Valentine&apos;s Day, and other seasonal
                occasions.
              </p>
              <p>
                Activity and event schedules can change. Guests should contact the park for current
                information.
              </p>
            </div>
          </Reveal>

          <div className="grid gap-4 sm:grid-cols-2">
            <MaskReveal className="media-zoom rounded-sm sm:col-span-2">
              <img
                src={main.src}
                srcSet={main.srcSet}
                sizes="(min-width: 1024px) 45vw, 100vw"
                alt={main.alt}
                width={main.width}
                height={main.height}
                loading="lazy"
                decoding="async"
                className="aspect-[16/10] w-full rounded-sm object-cover"
              />
            </MaskReveal>
            <MaskReveal className="media-zoom rounded-sm" delay={0.08}>
              <img
                src={side.src}
                srcSet={side.srcSet}
                sizes="(min-width: 1024px) 22vw, 50vw"
                alt={side.alt}
                width={side.width}
                height={side.height}
                loading="lazy"
                decoding="async"
                className="aspect-[4/3] w-full rounded-sm object-cover"
              />
            </MaskReveal>
            <MaskReveal className="media-zoom rounded-sm" delay={0.12}>
              <img
                src={detail.src}
                srcSet={detail.srcSet}
                sizes="(min-width: 1024px) 22vw, 50vw"
                alt={detail.alt}
                width={detail.width}
                height={detail.height}
                loading="lazy"
                decoding="async"
                className="aspect-[4/3] w-full rounded-sm object-cover"
              />
            </MaskReveal>
          </div>
        </div>
      </div>
    </section>
  );
}
